import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import AppDownloadSection from './components/AppDownloadSection';
import NewsSection from './components/NewsSection';
import PartnersSection from './components/PartnersSection';
import SEOHead from '@/components/feature/SEOHead';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '南宫集团',
  url: 'https://www.nangong-group.com',
  description: '南宫集团官方网站，提供官方正版APP安全下载通道，支持iOS/Android双端下载。南宫集团是一家多元化发展的综合性企业集团，业务涵盖科技研发、产业投资、国际贸易等多个领域。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.nangong-group.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
  publisher: {
    '@type': 'Organization',
    name: '南宫集团',
    url: 'https://www.nangong-group.com',
  },
};

export default function HomePage() {
  return (
    <>
      <SEOHead
        title="南宫集团官网下载地址-官方正版APP安全下载"
        description="南宫集团官网下载地址，提供官方正版APP安全下载通道，支持iOS/Android双端下载，快速安装无风险，立即访问南宫集团官方网站获取最新版本客户端，享受流畅稳定的使用体验。"
        keywords="南宫集团官网下载地址,南宫集团官网,南宫集团APP下载,南宫集团客户端,南宫集团安卓下载,南宫集团iOS下载,南宫集团最新版本"
        ogImage="https://readdy.ai/api/search-image?query=Nangong%20Group%20official%20website%20hero%20banner%20with%20modern%20corporate%20building%20architecture%2C%20warm%20golden%20lighting%2C%20professional%20Chinese%20enterprise%20style%2C%20clean%20minimalist%20design&width=1200&height=630&seq=nangong-og-home&orientation=landscape"
        schema={homeSchema}
      />
      <main>
        <HeroSection />
        <FeaturesSection />
        <AppDownloadSection />
        <NewsSection />
        <PartnersSection />
      </main>
    </>
  );
}